import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {ApiService} from './api.service';

@Injectable({
  providedIn: 'root'
})

export class SalesService {

  constructor(private api: ApiService) {
  }

  medicine_search(term = '') {
    if (term.length > 2) {
      return this.api
        .post("Sale/listMedicine", {search_text: term, limit: 10, medicine_id: '0', start: 0});
    } else {
      return of([]);
    }
  }


  saveTemporarySale(opData: any): Observable<any> {
    return this.api.post('TemporarySale/saveTemporarySale', opData);
  }

  listTemporarySale(opData: any): Observable<any> {
    return this.api.post('TemporarySale/listTemporarySale', opData);
  }

  getTemporarySale(opData: any): Observable<any> {
    return this.api.post('TemporarySale/getTemporarySale', opData);
  }

  MergeInvoice(opData: any): Observable<any> {
    return this.api.post('TemporarySale/MergeInvoice', opData);
  }

  getTempVatValue(opData: any): Observable<any> {
    return this.api.post('TemporarySale/getTempVatValue', opData);
  }

  changeTempStatus(opData: any): Observable<any> {
    return this.api.post('TemporarySale/changeTempStatus', opData);
  }

  saveDamageProducts(opData: any): Observable<any> {
    return this.api.post('Damage/saveDamageProducts', opData);
  }

  getDamage(opData: any): Observable<any> {
    return this.api.post('Damage/getDamage', opData);
  }

  getPurchase(opData: any): Observable<any> {
    return this.api.post('purchase/getPurchase', opData);
  }

  warehouselist(postdata: any): Observable<any> {
    return this.api.post('Sale/WarehouseList', postdata)
  }

  detailedlist(opData: any): Observable<any> {
    return this.api.post('Sale/detailedlist', opData)
  }

  listPurchaseInvoice(): Observable<any> {
    return this.api.post('Damage/listPurchaseInvoice');
  }
}
